import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $('.cr-copy').on('click', function () {
      const json = JSON.stringify($(this).data('value'));
      console.log(json);
      navigator.clipboard.writeText(json);
      $(this).blur();
      $(this).removeClass('btn-default');
      $(this).addClass('btn-success');
    });
  }
}